import { render } from "./custom_image_space.vue?vue&type=template&id=32e39161"
import script from "./custom_image_space.vue?vue&type=script&lang=js"
export * from "./custom_image_space.vue?vue&type=script&lang=js"

import "./custom_image_space.vue?vue&type=style&index=0&id=32e39161&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__